// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoogleOutlinedSvg from "@ant-design/icons-svg/es/asn/GoogleOutlined";
import AntdIcon from '../components/AntdIcon';

var GoogleOutlined = function GoogleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GoogleOutlinedSvg
  }));
};

GoogleOutlined.displayName = 'GoogleOutlined';
export default React.forwardRef(GoogleOutlined);